export class CashValueByCashType {
    /**Totale importo banconote */
    banknoteCashValue: number;

    /**Totale importo monete */
    coinCashValue: number;

    constructor() { }

    public parse(obj: any) {
        if (obj.BanknoteCashValue != null) this.banknoteCashValue = obj.BanknoteCashValue;
        if (obj.CoinCashValue != null) this.coinCashValue = obj.CoinCashValue;
    }

}